import api from "./api";

const collegeService = {
  getUniversities: async () => {
    const response = await api.get("/api/college/universities");
    return response.data.data.universities;
  },

  // Added by Farhan Khan on 22-June-2026 ( Using this to Fetch Active Data for dropdown )
  getActiveUniversities: async () => {
    const response = await api.get("/api/college/universities/active");
    return response.data.data || response.data;
  },

  getCourses: async (universityId) => {
    const response = await api.get(`/api/college/courses?university_id=${universityId}`);
    return response.data.data.courses;
  },

  // Added by Farhan Khan on 22-June-2026 ( Using this to Fetch Active Data for dropdown )
  getActiveCourses: async (universityId) => {
    const response = await api.get(`/api/college/courses/university/${universityId}/active`);
    return response.data.data || response.data;
  },

  getSemesters: async (courseId) => {
    const response = await api.get(`/api/college/semesters?course_id=${courseId}`);
    return response.data.data.semesters;
  },

  // Added by Farhan Khan on 22-June-2026 ( Using this to Fetch Active Data for dropdown )
  getActiveSemesters: async (courseId) => {
    const response = await api.get(`/api/college/semesters/course/${courseId}/active`);
    return response.data.data || response.data;
  },
};

export default collegeService;
